<template>
  <div
    id="message-list"
    class="SB-border top" >
    <Spinner
      v-if="!tempConversation &&
        (!meta || forceLoadingSpinner || (messagesLoading && page === 1))"
      :thickness="2"
      class="mt-3 mb-3" />
    <!-- Messages -->
    <ScrollArea
      v-else
      ref="messageScrollbar"
      class="messages-scroll-area"
      :top-offset="100"
      @top="handleTopScroll"
      @bottom="handleBottomScroll"
      @noScroll="handleBottomScroll"
    >
      <div v-if="conversationSelected">
        <!-- Show at the start of the conversation. -->
        <div
          v-if="noMoreMessages"
          class="conversation-start operator-message text-center">
          <span class="emoji-fix">👋</span>
        </div>
        <!-- Messages loading -->
        <Spinner
          v-else
          :thickness="2"
          class="mt-3 mb-3" />
        <div
          v-for="(messagesChunk, chunkIndex) in messagesChunks"
          :key="chunkIndex"
          class="day-wrapper"
        >
          <!-- <div
            v-if="index === 0 || index > 0 && !isSameDay(message.sent_at, messages[index - 1].sent_at)"
            class="time-flag">
            <p>{{ message.sent_at | messagesMainDate }}</p>
          </div> -->
          <span class="time-flag">
            <p>
              {{ noMoreMessages && chunkIndex === 0 ? 'Conversation started ' : '' }}
              {{ noMoreMessages && chunkIndex === 0 && lastMessageBeforeYesterday ? 'on' : '' }}
              {{ messagesChunk[0].timestamp | messagesMainDate }}</p>
          </span>
          <div
            v-for="(message, messageIndex) in messagesChunk"
            :id="`message-${message.sid}`"
            :key="messageIndex"
            class="message-wrapper"
            :class="[
              {
                'unseen': lastSeenMessageTimestamp === message.timestamp && showTheUnseenMarker,
                'small-top-margin': (messageIndex === 0) || (messageIndex > 0 && showSubMessage(messagesChunk[messageIndex - 1], message))
              },
              $options.filters.hyphen(message.direction)
            ]"
          >
            <div
              v-if="message.direction !== 'activity'"
              :id="`message-target-${message.sid}`"
              class="message"
              @mouseenter="showTooltip(message.sid)"
              @mouseleave="hideTooltip(message.sid)" >
              <ContextPreview
                v-if="message.context_preview && message.context_preview.length"
                class="ml-auto"
                :class="{ first: message.body }"
                :context-message="message" />
              <div
                v-if="message.context"
                class="reply-message-origin" >
                <div class="header flex flex-align-center">
                  <SBIcon
                    class="mr-1"
                    :icon="SBIconList.REPLY_SINGLE"
                    :color="SBColors.blackUltralight"
                    :size="9" />
                  <p>Replied to {{ message.direction === 'inbound' ? (message.context.direction === 'inbound' ? 'themself' : 'you') : (message.context.direction === 'inbound' ? (activeConversation.contact.name ? activeConversation.contact.name : activeConversation.contact.phone) : 'yourself') }}</p>
                </div>
                <div class="body">
                  <MediaMessage
                    v-if="isMediaMessage(message.context)"
                    :message="message.context"
                    force-black />
                  <LocationMessage
                    v-else-if="
                      (message.context.media_type && message.context.media_type === 'location') ||
                        (message.context.type && message.context.type === 'location')
                    "
                    :location="message.context.media_url || message.context.body"
                  />
                  <p
                    v-else
                    :class="{ 'text-arabic': isRightAlignedText(message.context.body || '') }"
                    class="text-message"
                  >
                    <MessageContent
                      :content="message.context.body"
                      :detect-urls="true" />
                  </p>
                </div>
              </div>
              <div
                class="body-wrapper flex flex-align-center"
                :class="{ 'cloud-api': cloudApiSupport[activeConversation.business_id] }">
                <div
                  v-if="message.status !== 'failed'"
                  class="message-actions flex center-all">
                  <div
                    v-if="message.reaction && message.direction === 'inbound'"
                    class="reaction-wrapper flex">
                    <span
                      v-for="(reaction, index) in message.reaction"
                      :id="`reaction-${message.id}-${index}`"
                      :key="index"
                      class="reaction flex center-all relative"
                      :class="{ contact: reaction.sender.name === 'contact' }" >
                      {{ reaction.emoji }}

                      <!-- -------------------------------------------------------------- -->
                      <!--                          EMOJI DELETE                          -->
                      <!-- -------------------------------------------------------------- -->
                      <!-- Emoji remove is not supported by gupshup at the moment.        -->
                      <!-- Just uncomment this and test once it becomes available.        -->
                      <!-- -------------------------------------------------------------- -->

                      <!-- <SBIcon
                        v-if="reaction.sender.name !== 'contact'"
                        class="remove-emoji show-hand"
                        :icon="SBIconList.CLOSE_THIN"
                        :color="SBColors.white"
                        :background-color="SBColors.blackPrimary"
                        hover-color="#ff5b61"
                        :size="8"
                        :hover-size="16"
                        :border-radius="50"
                        @click.native="removeEmoji($event, message)" /> -->

                      <b-popover
                        :target="`reaction-${message.id}-${index}`"
                        triggers="hover"
                        boundary="window"
                        placement="top"
                        custom-class="sender-popover basic-popover"
                        :delay="0" >
                        <SBAvatar
                          v-if="reaction.sender.name === 'contact'"
                          :class="{}"
                          class="team-member person-avatar"
                          size="m-button"
                          :show-data="true"
                          :show-client="true"
                          :show-name="true"
                          :show-phone="true"
                          :person="activeConversation.contact"
                          :character-count="1" />
                        <div
                          v-else
                          class="flex center-all">
                          <SBAvatarImage
                            class="item-icon mr-2"
                            :size="SBAvatarImageSize.W30"
                            :name="reaction.sender.name ? reaction.sender.name : '?'"
                            :image="getMemberByPlatformId(reaction.sender.id) ? getMemberByPlatformId(reaction.sender.id).avatar : ''" />
                          <h3>{{ reaction.sender.name }}</h3>
                        </div>
                      </b-popover>
                    </span>
                  </div>
                  <SBIcon
                    v-if="message.direction === 'inbound'"
                    :id="`message-reply-${message.sid}`"
                    class="message-action show-hand"
                    :class="{ force: emojiTarget && message.id === emojiTarget.id}"
                    :data-emoji-selector="true"
                    :icon="SBIconList.EMOJI"
                    color="#54626c"
                    :hover-icon="SBIconList.EMOJI_COLOR"
                    background-color="#f2f5f7"
                    :size="12"
                    :hover-size="24"
                    :border-radius="50"
                    :mask-hover="false"
                    @click.native="toggleEmoji($event, message)" />
                  <SBIcon
                    v-if="message.direction === 'inbound' && !sessionWindowClosed"
                    :id="`message-emoji-${message.sid}`"
                    class="message-action show-hand"
                    :class="{ force: emojiTarget && message.id === emojiTarget.id}"
                    :icon="SBIconList.REPLY_SINGLE"
                    color="#54626c"
                    background-color="#f2f5f7"
                    :hover-icon-color="SBColors.blackPrimary"
                    :size="12"
                    :hover-size="24"
                    :border-radius="50"
                    @click="startReply(message)" />
                  <div
                    v-if="message.reaction && message.direction !== 'inbound'"
                    class="reaction-wrapper to-right flex">
                    <span
                      v-for="(reaction, index) in message.reaction"
                      :id="`reaction-${message.id}-${index}`"
                      :key="index"
                      class="reaction flex center-all relative"
                      :class="{ contact: reaction.sender.name === 'contact' }" >
                      {{ reaction.emoji }}

                      <!-- -------------------------------------------------------------- -->
                      <!--                          EMOJI DELETE                          -->
                      <!-- -------------------------------------------------------------- -->
                      <!-- Emoji remove is not supported by gupshup at the moment.        -->
                      <!-- Just uncomment this and test once it becomes available.        -->
                      <!-- -------------------------------------------------------------- -->

                      <!-- <SBIcon
                        v-if="reaction.sender.name !== 'contact'"
                        class="remove-emoji show-hand"
                        :icon="SBIconList.CLOSE_THIN"
                        :color="SBColors.white"
                        :background-color="SBColors.blackPrimary"
                        hover-color="#ff5b61"
                        :size="8"
                        :hover-size="16"
                        :border-radius="50"
                        @click.native="removeEmoji($event, message)" /> -->

                      <b-popover
                        :target="`reaction-${message.id}-${index}`"
                        triggers="hover"
                        boundary="window"
                        placement="top"
                        custom-class="sender-popover basic-popover"
                        :delay="0" >
                        <SBAvatar
                          v-if="reaction.sender.name === 'contact'"
                          :class="{}"
                          class="team-member person-avatar"
                          size="m-button"
                          :show-data="true"
                          :show-client="true"
                          :show-name="true"
                          :show-phone="true"
                          :person="activeConversation.contact"
                          :character-count="1" />
                        <div
                          v-else
                          class="flex center-all">
                          <SBAvatarImage
                            class="item-icon mr-2"
                            :size="SBAvatarImageSize.W30"
                            :name="reaction.sender.name ? reaction.sender.name : '?'"
                            :image="getMemberByPlatformId(reaction.sender.id) ? getMemberByPlatformId(reaction.sender.id).avatar : ''" />
                          <h3>{{ reaction.sender.name }}</h3>
                        </div>
                      </b-popover>
                    </span>
                  </div>
                </div>
                <div class="message-elements flex column relative" >
                  <SBIcon
                    v-if="message.status === 'failed'"
                    :id="`message-failed-info-${message.sid}`"
                    class="message-info"
                    :class="{ 'message-info': !isMediaMessage(message) }"
                    :icon="SBIconList.INFO"
                    color="#f5bfc1"
                    :size="12"
                    :hover-size="24" />
                  <div
                    class="message-body flex flex-align-center"
                    :class="[
                      messagePositionInGroup(
                        messagesChunk[messageIndex - 1],
                        messagesChunk[messageIndex],
                        messagesChunk[messageIndex + 1]
                      ),
                      {
                        'audio-message': isAudioMessage(message),
                        'has-buttons': message.buttons,
                        failed: message.status === 'failed',
                      },
                    ]"
                  >
                    <MediaMessage
                      v-if="isMediaMessage(message)"
                      :message="message" />
                    <LocationMessage
                      v-else-if="
                        (message.media_type && message.media_type === 'location') ||
                          (message.type && message.type === 'location')
                      "
                      :location="message.media_url || message.body"
                    />
                    <p
                      v-else
                      :class="{ 'text-arabic': isRightAlignedText(message.body || '') }"
                      class="text-message"
                    >
                      <MessageContent
                        :content="message.body"
                        :detect-urls="true" />
                      <template v-if="message.actions">
                        <span
                          v-for="action in message.actions"
                          :key="action._id"
                          class="message-action"
                        >
                          {{ action.text ? `${action.text} ` : "" }}
                          <a
                            v-if="action.type === 'link'"
                            :href="action.uri"
                            target="_blank"
                          >{{ action.uri }}</a
                          >
                        </span>
                      </template>
                    </p>
                  </div>
                  <MessageButtons
                    v-if="message.buttons"
                    :message="message"
                    :class="[
                      messagePositionInGroup(
                        messagesChunk[messageIndex - 1],
                        messagesChunk[messageIndex],
                        messagesChunk[messageIndex + 1]
                      )
                    ]" />
                </div>
              </div>

              <div
                v-if="showSubMessage(message, messagesChunk[messageIndex + 1])"
                class="sub-message"
              >
                <template v-if="message.ai_reasoning">
                  <div
                    :id="`thoughts-${message.sid}`"
                    class="flex ai-sources" >
                    <SBIcon
                      :icon="SBIconList.BULB"
                      :color="SBColors.blackUltralight"
                      :size="12"
                      class="mr-1" />
                    <p class="" >Thoughts</p>
                  </div>
                  <DotSeparator
                    :size="3"
                    class="ml-1 mr-1" />
                  <b-popover
                    :id="`thoughts-${message.sid}-popover`"
                    :target="`thoughts-${message.sid}`"
                    triggers="hover"
                    placement="top"
                    custom-class="thoughts-popover"
                    boundary-padding="0" >
                    <div
                      v-for="(thought, index) in message.thoughts"
                      :key="index"
                      class="flex column ai-thought" >
                      <h3 v-if="thought.title">{{ thought.title }}</h3>
                      <p v-if="thought.description">{{ thought.description }}</p>
                    </div>
                  </b-popover>
                </template>
                <template v-if="message.ai_file_sources && message.ai_file_sources.length">
                  <div
                    :id="`sources-${message.sid}`"
                    class="flex ai-sources" >
                    <SBIcon
                      :icon="SBIconList.ADD_FILES"
                      :color="SBColors.blackUltralight"
                      :size="12"
                      class="mr-1" />
                    <p class="" >{{ message.ai_file_sources.length }} source{{ message.ai_file_sources.length > 1 ? 's' : '' }}</p>
                  </div>

                  <DotSeparator
                    :size="3"
                    class="ml-1 mr-1" />

                  <b-popover
                    :id="`sources-${message.sid}-popover`"
                    :target="`sources-${message.sid}`"
                    triggers="hover"
                    placement="top"
                    custom-class="sources-popover"
                    boundary-padding="0" >
                    <h3>{{ message.ai_file_sources.length }} source{{ message.ai_file_sources.length > 1 ? 's' : '' }}</h3>
                    <div
                      v-for="(source, index) in message.ai_file_sources"
                      :id="`sources-${message.sid}-s-${index}`"
                      :key="index"
                      class="d-block flex flex-align-center"
                      :class="source.exists ? '' : 'not-found'"
                      @click="() => { source.exists ? followLink(source.url) : null }" >
                      <SBIcon
                        :icon="source.exists ? (source.name.indexOf('http') === 0 ? SBIconList.FOLDER_TICK : SBIconList.TICK_FILE) : SBIconList.CLOSE_THIN"
                        :color="source.exists ? SBColors.blackPrimary : SBColors.greyLight"
                        :size="12"
                        class="mr-1" />
                      <p class="m-0 ellipsis">{{ source.name | domainSimplified }}</p>
                      <SBIcon
                        v-if="source.exists"
                        :icon="SBIconList.ARROW_45"
                        :color="source.exists ? SBColors.greyPrimary : SBColors.greyLight"
                        :size="12"
                        class="mr-1" />
                      <b-popover
                        v-if="!source.exists"
                        :target="`sources-${message.sid}-s-${index}`"
                        triggers="hover"
                        placement="top"
                        custom-class="basic-popover sources-popover-inner"
                        boundary-padding="0"
                        :container="`sources-${message.sid}-popover`" >
                        {{ source.name.indexOf('http') === 0 ? 'This web page was removed from the knowledge base.' : 'This file was removed from the knowledge base.' }}
                      </b-popover>
                    </div>
                  </b-popover>
                </template>
                <template
                  v-if="message.direction !== 'inbound'"
                >
                  <!-- <Sender :message="message" /> -->
                  <img
                    v-if="message.sender_icon && Number(message.sender_icon) && getMemberAvatar(message).avatar"
                    :src="getMemberAvatar(message).avatar"
                    class="avatar"
                    :alt="message.sender" >
                  <SBAvatar
                    v-else-if="message.agent"
                    class="no-shrink avatar"
                    size="conversation-avatar"
                    :show-data="true"
                    :character-count="1"
                    :gradient1="SBColors.blackPrimary"
                    :gradient2="SBColors.blackPrimary"
                    :text-color="SBColors.white"
                    :person="{name: message.sender}"
                    :show-client="true"
                    :hide-avatar-image="true" />
                  <img
                    v-else-if="message.sender_icon && message.sender_icon.grey"
                    class="sender-icon"
                    :src="message.sender_icon.grey" >
                  <template v-if="message.sender">
                    <p class="ellipsis">{{ message.sender }}</p>
                    <DotSeparator
                      :size="3"
                      class="ml-1 mr-1" />
                  </template>
                  <template v-if="message.message_type">
                    <p class="ellipsis">{{ message.message_type }}</p>
                    <DotSeparator
                      :size="3"
                      class="ml-1 mr-1" />
                  </template>
                </template>
                <p>
                  {{ message.timestamp | subMessageDate }}
                </p>
                <!-- <p
                  v-if="message.status === 'failed'"
                  class="error-color show-hand flex center-all"
                  @click="sendRetry(message)"
                >
                  Message was not delivered,&nbsp;<b>click to retry</b>.
                  {{ message.error_message }}
                </p> -->
                <DeliveryStatus
                  v-if="message.direction !== 'inbound'"
                  :status="message.status === 'delivered' && message.timestamp < lastReadMessageTime ? 'read' : message.status"
                />
              </div>
              <!-- Previous target was message info
              :target="`message-failed-info-${message.sid}`" -->
              <b-popover
                v-if="message.status === 'failed' && message.error_message"
                :ref="`message-failed-info-ref-${message.sid}`"
                :target="`message-failed-info-${message.sid}`"
                :custom-class="`red blue-href to-right-4 dyn-popover-${message.sid}`"
                boundary="window"
                placement="left" >
                <h1>Error message</h1>
                <p v-html="message.error_message" />
                <p v-if="incognito">{{ message.fail_reason }}</p>
              </b-popover>
            </div>
            <div
              v-else
              class="operator-message flex center-all">
              <!-- <SBIcon
                v-if="message.direction === 'activity' && message.action === 'Block'"
                class="mr-1"
                :icon="SBIconList.BLOCK"
                :color="SBColors.blackUltralight"
                :size="12" /> -->
              <p>
                <span
                  v-if="message.action === 'assignment'"
                  class="emoji-fix">{{ !message.to_user_id ? '⤴️' : me.id === message.to_user_id ? '⬅️' : '➡️' }}</span>
                <span
                  v-if="message.action === 'folder'"
                  class="emoji-fix">{{ message.meta_data.new_folder === 'done' ? '👍' : message.meta_data.new_folder === 'open' ? '↩️' : '' }}</span>
                {{ configureActivityMessage(message) }}
              </p>
            </div>
          </div>
        </div>

        <!-- TODO - Do we have a situation when there is an empty conversation? -->
        <!-- v-if="(messagesLoaded && !messages.length) || !conversationExists" -->
        <!-- <div
          class="no-messages">
          <div class="info">
            <img src="~@/assets/img/no-messages.svg">
            <h6>
              No messages to show
            </h6>
          </div>
        </div> -->

        <Picker
          v-show="showEmojiPicker"
          v-click-outside="closeEmojis"
          class="emoji-picker"
          :style="{ top: pickerTop, left: pickerLeft }"
          set="emojione"
          title="Pick your emoji..."
          emoji="point_up"
          :native="true"
          @select="emojiSelected" />
      </div>
    </ScrollArea>
    <div class="pill-bottom-container flex column center-all">
      <transition-group
        name="fade-list"
        tag="div"
        class="flex column center-all" >
        <span
          v-for="(pillMessage, id, _index) in pillMessages"
          :key="id"
          :ref="`pillMessage-${id}`"
          class="pill-bottom"
          :class="{ error: pillMessage.type === PillMessageType.ERROR }"
          @click.self="pillMessage.callback(id, pillMessage, _index)"
        >
          <!-- TODO remove _index and get tsLint to accept the no-unused-vars rule which is now comented out in config -->
          <SBIcon
            v-if="pillMessage.iconLeft"
            :icon="pillMessage.iconLeft"
            :color="SBColors.bluePrimary"
            :size="15"
          />
          {{ pillMessage.message }}
          <SBIcon
            v-if="pillMessage.closeBtn"
            :icon="SBIconList.CLOSE_THIN"
            :color="SBColors.redPrimary"
            :size="8"
            class="ml-2"
            @click="removePill(id, true)"
          />
        </span>
      </transition-group>
    </div>
    <ConversationOpenedCountdown
      v-if="!contactIsBlocked && !contactOpOuted" />
  </div>
</template>

<style lang="scss" scoped>
.fade-list-enter-active:not(.no-animation),
.fade-list-leave-active:not(.no-animation) {
  transition: all 0.25s;
}
.fade-list-enter:not(.no-animation),
.fade-list-leave-to:not(.no-animation) {
  opacity: 0;
  transform: translateY(3px);
}
#message-list {
  flex-grow: 2;
  overflow: hidden;
  position: relative;
  margin-right: 1px;

  ::v-deep .message-wrapper {
    .emoji-fix {
      font-size: inherit !important;
    }
  }

  ::v-deep .messages-scroll-area {
    height: 100%;
    padding: 0 15px;

    &.v-scroll-visible {
      padding: 0 12px 0 15px;
    }

    .conversation-start {
      margin-top: 22px !important;
      margin-bottom: 22px !important;

      .emoji-fix {
        font-size: 30px !important;
        margin-right: 0px !important;
      }
    }

    .operator-message {
      font-size: 12px;
      font-weight: 500;
      line-height: 1.2 !important;
      text-align: center;
      margin: 15px;
      color: $blackUltralight;
    }

    .day-wrapper {
      .time-flag {
        position: -webkit-sticky;
        position: sticky;
        top: 10px;
        display: flex;
        justify-content: center;
        margin-top: 0px;
        margin-bottom: 5px;
        z-index: 1;

        p {
          // font-family: 'InterSB' !important;
          font-size: 12px;
          font-weight: 500;
          line-height: 1 !important;
          color: $blackUltralight;
          background-color: $greyChatBubble;
          padding: 4px 15px;
          border-radius: 50px;
          box-shadow: 0 0 3px 0 rgb(48 54 70 / 30%);
        }
      }

      .message-wrapper {
        display: flex;
        flex-direction: row-reverse;

        &:first-of-type {
          margin-top: 30px;
          &.small-top-margin {
            margin-top: 15px;
          }
        }

        &:last-of-type {
          padding-bottom: 30px;
        }

        &.activity {
          justify-content: center;
          .operator-message {
            font-size: 12px;
            font-weight: 500;
            line-height: 1.4;
            text-align: center;
            margin: 15px;
            color: $blackUltralight;

            .emoji-fix {
              font-size: 12px;
            }
          }
        }

        .reply-message-origin {
          position: relative;

          &::before {
            content: '';
            position: absolute;
            border-left: 2px solid #7dbcfa;
            height: calc(100% - 18px);
            bottom: 0;
          }
          
          .header {
            font-size: 12px;
            color: $blackUltralight;
            margin: 15px 0 6px;
          }

          .body {
            border-radius: 15px;
            border: 2px solid $lightGray;
            overflow: hidden;
            margin-left: 9px;
            width: fit-content;
            white-space: pre-wrap;
            overflow-wrap: anywhere;

            .text-message {
              background-color: $lightGray;
              padding: 5px 10px;
              width: fit-content;
              font-size: 12px;
              line-height: 1.2;

              img {
                width: 14px;
                height: 14px;
                margin: 0 1px;
                vertical-align: -2px !important;
              }
            }



            .media-message {
              background-color: $lightGray;

              .media-image {
                width: 157px;
                height: 157px;

                .SB-lightbox-trigger.show-play-overlay {
                  background-size: 50px;
                }
              }

              .caption {
                font-size: 12px;
                max-width: 157px;

                img {
                  width: 14px;
                  height: 14px;
                  margin: 0 1px;
                  vertical-align: -2px !important;
                }
              }
            }

            .media-audio {
              .audio-player {
                padding: 4px 10px;
                font-size: 12px;
                background-color: $lightGray;

                .sb-icon span.icon {
                  width: 9px;
                  height: 9px;
                  mask-size: 9px 9px !important;
                }

                .progress-wrapper {
                  margin-left: 12px;

                  .progress {
                    height: 2px;

                    &::after {
                      width: 6px;
                      height: 6px;
                      top: 4px;
                    }
                  }
                }

                .time {
                  min-width: 87px;
                }
              }
            }

            .media-file {
              font-size: 12px;

              a, .pdf-download {
                font-size: 12px;
                padding: 6px 12px 6px 7px;
                // background-color: $blackUltralight;
                // color: $greyChatBubble !important;

                * {
                  // color: $greyChatBubble !important;
                }

                .sb-icon {
                  width: 13px;
                  height: 13px;
                  .icon.mask {
                    width: 13px;
                    height: 13px;
                    background-size: 13px;
                    mask-size: 13px 13px !important;
                    // background-color: $greyChatBubble !important;
                  }
                }
              }

              .media-caption {
                padding: 5px 10px!important;
              }

              &:not(.basic) {
                a, .pdf-download {
                  background-color: #939FA3;
                  color: $white !important;

                  * {
                    color: $white !important;
                  }

                  .sb-icon {
                    .icon.mask {
                      background-color: $white !important;
                    }
                  }
                }
              }
            }

            .location-message {
              /* 20% smaller than original */
              a {
                height: 120px;
                width: 176px;
              }
            }
          }

          margin-bottom: 6px;
        }

        .message {
          display: inline-block;
          max-width: 75%;

          .context-message {
            border: solid 1px #e1e7e9 !important;
            border-radius: 15px;
            background: $white;
            overflow: hidden;
            margin-top: 3px;
            margin-bottom: 3px;

            &.first {
              border-bottom-right-radius: 3px;
            }
          }

          .sub-message {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            margin-top: 4px;
            margin-bottom: 7px;
            font-size: 12px;
            // line-height: 1.4;
            color: $blackUltralight;

            .ai-sources {
              border-bottom: 1px dashed $blackUltralight;
              padding-bottom: 2px;

              &:hover, &.active {
                cursor: default;
                color: $blackPrimary;
                border-bottom: 1px dashed $blackPrimary;

                .sb-icon .mask {
                  background-color: $blackPrimary !important;
                }
              }
            }

            .avatar {
              height: 14px;
              width: 14px;
              border-radius: 50px;
              aspect-ratio: 1 / 1;
              object-fit: cover;
            }

            .sender-icon{
              height: 12px;
              flex-shrink: 0;
              margin-right: 4px;
            }

            .avatar {
              margin-right: 4px;
              position: relative;
              // top: -1px;
            }
          }

          .message-actions {
            z-index: 99;
            .message-action {
              margin-right: 5px;
              opacity: 0;
              display: none;
              &.force {
                opacity: 1;
              }
            }

            .reaction-wrapper {
              margin-left: -4px;
              z-index: 9;
              .reaction {
                display: block;
                border-radius: 50px;
                margin-left: -4px;
                width: 28px;
                height: 28px;
                box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.25);
                background-color: var(--white);
                font-size: 14px;
                // EMOJI DELETE - change this to 'pointer' when emoji delete becomes available on Gupshup
                cursor: default;

                &.contact {
                  cursor: default;
                }

                .remove-emoji {
                  opacity: 0;
                  position: absolute;
                  top: -4px;
                  right: -4px;
                }

                &:hover {
                  .remove-emoji {
                    opacity: 1;
                  }
                }
              }

              &.to-right {
                margin-left: 0px;
                margin-right: -4px;

                .reaction {
                  margin-left: 0px;
                  margin-right: -4px;
                }
              }
            }
          }
        }

        .message .message-body {
          white-space: pre-wrap;
          overflow-wrap: anywhere;
          max-width: max-content;
          margin-left: auto;
          margin-right: 0;
          margin-top: 1px;
          margin-bottom: 1px;
          border-radius: 3px;
          border-top-left-radius: 19px;
          border-bottom-left-radius: 19px;
          font-size: 14px;
          line-height: 1.2;
          color: $white;
          overflow: hidden;
          background: $bluePrimary;
          border: 3px solid $bluePrimary;
          width: 100%;
          max-width: 100%;

          &.failed {
            background: $redPrimary;
            border: 3px solid $redPrimary;
            color: $white !important;

            .audio-player {
              background-color: $redPrimary;
            }
          }

          ::v-deep a {
            color: $white !important;
            text-decoration: none;
          }

          &.audio-message {
            border-top-left-radius: 10px;
            border-bottom-left-radius: 10px;
          }

          .text-message {
            padding: 4px 11px;
          }

          p img {
            width: 16px;
            height: 16px;
            margin: 0 1px;
            vertical-align: -3px !important;
          }

          &.first {
            border-top-right-radius: 19px;
          }
          &.last {
            border-bottom-right-radius: 19px;
          }

          &.audio-message.first {
            border-top-right-radius: 10px;
          }

          &.audio-message.last {
            border-bottom-right-radius: 10px;
          }

          &.has-buttons {
            border-bottom-right-radius: 3px;
            border-bottom-left-radius: 3px;
            margin-bottom: 0 !important;
            margin-left: unset !important;
            max-width: unset !important;
          }
        }

        .message .last {
          .button:last-of-type {
            border-radius: 3px 3px 18px 18px;
          }
        }

        &.outbound, &.template-message, &.bot {
          ::v-deep .media-message a {
            color: $white !important;
          }

          .message {
            .message-elements {
              max-width: max-content;
              // margin-left: auto;
              justify-content: flex-end;

              .message-info {
                // margin: 0 -12px 0 3px;
                position: absolute;
                left: -24px;
                top: calc(50% - 12px);
              }
            }
            .message-body {
              a {
                color: $white !important;
                text-decoration: underline;
              }
            }
          }
        }

        &.outbound {

          .reply-message-origin {
            .header {
              justify-content: flex-end;
            }

            .body {
              margin-left: auto;
              margin-right: 9px;
            }

            &::before {
              border-left: none;
            }

            &::after {
              content: '';
              position: absolute;
              border-right: 2px solid #7dbcfa;
              height: calc(100% - 18px);
              bottom: 0;
              right: 0;
            }
          }

          .body-wrapper {
            justify-content: flex-end;
          }
        }

        &.inbound {
          flex-direction: row;

          .message-elements {
              min-width: fit-content;
              max-width: calc(100% - 80px); // 80px is the width of the actions that show on hover + emoji reaction
            }

          .message {
            .body-wrapper {
              flex-direction: row-reverse;
              justify-content: flex-end;
              .message-actions {
                .message-action {
                  margin-left: 5px;
                  margin-right: 0;
                }
              }
            }
            .message-body {
              margin-left: 0;
              margin-right: auto;
              background: $greyChatBubble;
              border: 3px solid $greyChatBubble;
              border-top-right-radius: 19px;
              border-bottom-right-radius: 19px;
              border-top-left-radius: 3px;
              border-bottom-left-radius: 3px;
              color: $blackPrimary;

              a {
                color: $blackPrimary !important;
                text-decoration: underline;
              }

              &.first {
                border-top-left-radius: 19px;
              }
              &.last {
                border-bottom-left-radius: 19px;
              }

              .media-file:not(.basic) {

                a, .pdf-download {
                  background-color: $blackUltralight;
                  color: $greyChatBubble !important;

                  * {
                    color: $greyChatBubble !important;
                  }

                  .sb-icon {
                    .icon.mask {
                      background-color: $greyChatBubble !important;
                    }
                  }
                }
              }
            }
            .sub-message {
              justify-content: start;
            }
          }
        }

        &.unseen {
          padding-top: 42px;
          position: relative;
        }

        &.unseen::before {
          content: '';
          position: absolute;
          top: 20px;
          right: 0;
          left: 0;
          border-top: 1px solid $bluePrimary;
        }

        &.unseen::after {
          content: 'New';
          color: $bluePrimary;
          display: block;
          position: absolute;
          top: 14px;
          padding: 0 10px;
          left: calc(50% - 26px);
          text-align: center;
          background: $white;
          font-size: 12px;
          font-weight: 500;
        }

        // Prevents multiple unseen markers to be shown.
        &.unseen ~ .unseen {
          padding-top: 0 !important;
          &::before, &::after {
            display: none !important;
          }
        }

        &.small-top-margin {
          &.unseen {
            padding-top: 35px;
          }

          &.unseen::before {
            top: 13px;
          }

          &.unseen::after {
            top: 7px;
          }
        }

        &:hover {
          .body-wrapper.cloud-api .message-actions .message-action {
            display: inherit;
            opacity: 1;
          }
        }
      }

      &:last-of-type .activity:last-of-type {
        // margin-bottom: 30px;
      }
    }
  }

  .pill-bottom-container {
    position: absolute;
    bottom: 8px;
    left: 0;
    right: 0;
    z-index: 60;

    .pill-bottom {
      display: inline-flex;
      align-items: center;
      padding: 7px 10px;
      margin-top: 8px;
      color: $bluePrimary;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      z-index: 50;
      line-height: 1.2;
      border-radius: 50px;
      box-shadow: 0 0 8px 0 rgba(48, 54, 70, 0.2);
      background-color: $white;

      .sb-icon {
        margin-right: 4px;
      }

      &.error {
        background: $redUltraLight;
        color: $redPrimary;
        box-shadow: unset !important;
      }
    }
  }
}

.emoji-picker {
  position: absolute;
  z-index: 1000;

  ::v-deep .emoji {
    border: none !important;
  }
}

::v-deep {
  .sb-avatar .logo.conversation-avatar {
    background: $blackUltralight;
  }
}
</style>

<style lang="scss">
.to-right-4 {
  margin-right: 6px !important;
}

.sender-popover {
  h3 {
    font-weight: 500;
  }
}

.sources-popover,
.thoughts-popover {
  max-width: 415px;

  .popover-body {
    padding: 15px !important;
    max-height: 400px;
    overflow-y: auto;

    h3 {
      font-size: 14px;
      font-weight: 500;
      color: $bluePrimary;
    }

    & > div {
      border-bottom: 1px dashed $greyBorder;
      padding: 10px 0;
      color: $blackPrimary;

      &:last-of-type {
        border-bottom: none;
        padding: 9px 0 0;
      }

      p {
        line-height: 1 !important;
      }

      &:not(.not-found):hover {
        cursor: pointer;
        text-decoration: underline;

        .sb-icon .mask {
          background-color: $blackPrimary !important;
        }
      }

      &.not-found * {
        color: $greyLight !important;
      }
    }
  }
}

.sources-popover-inner {
  max-width: 500px;
}

.thoughts-popover {
  .popover-body {
    & > div {
      border-bottom: none;
      padding: 0;

      &:hover {
        cursor: default !important;
        text-decoration: none !important;
      }
    }

    .ai-thought {
      padding-top: 15px !important;
      &:first-child {
        padding-top: 0px !important;
      }
    }
  }
}
</style>

<script>
import { mapActions, mapGetters } from 'vuex';
import { isRightAlignedText } from '@/helpers/stringHelpers';
import moment from '@/helpers/momentz';
import { Picker } from 'emoji-mart-vue';

import randomString from '@/helpers/randomString';
import DotSeparator from '@/components/common/DotSeparator';
import MessageContent from '@/components/common/MessageContent';
import ScrollArea from '@/components/common/ScrollArea';
import Spinner from '@/components/common/Spinner';
// import Sender from '@/components/business/chat/partials/Sender';
import DeliveryStatus from '@/components/business/chat/partials/DeliveryStatus';
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import { addClass } from '@/helpers/elementUtils';
import PillMessageType from '@/helpers/lists/pillMessageTypes';
import ToasterMixin from '@/mixins/Toaster';
import deliveryStatusLevels from '@/helpers/lists/deliveryStatusLevels';
import UserPermissionsMixin from '@/mixins/UserPermissions.mixin';
import ConversationOpenedCountdown from '@/components/business/chat/ConversationOpenedCountdown';
import MessageButtons from '@/components/business/chat/partials/MessageButtons';
import SBAvatar from '@/components/common/Avatar';
import SBAvatarImage from '@/components/common/AvatarImage';
import SBAvatarImageSize from '@/helpers/lists/avatarSize';
import LocationMessage from './LocationMessage';
import MediaMessage from './MediaMessage';
import ContextPreview from './ContextPreview';

export default {
  name: 'MessageList',
  components: {
    DotSeparator,
    LocationMessage,
    ContextPreview,
    MediaMessage,
    MessageContent,
    ScrollArea,
    Spinner,
    // Sender,
    DeliveryStatus,
    SBIcon,
    ConversationOpenedCountdown,
    MessageButtons,
    SBAvatar,
    SBAvatarImage,
    Picker,
  },
  mixins: [
    ToasterMixin,
    UserPermissionsMixin,
  ],
  data() {
    return {
      lastPage: false,
      messages: [],
      nextMessagesBefore: null,
      page: 0,
      isScrollPositionOnBottomBeforeNewInboundMessage: true,
      showScrollBottomShown: false,
      userId: localStorage.getItem('userId'),
      pillMessages: {},
      pillScrollBottomId: null,
      forceLoadingSpinner: false,
      lastReadMessageTime: 0,
      meta: null,
      SBIconList,
      unseenMarkerCount: 0,
      showTheUnseenMarker: false,
      lastSeenMessageTimestamp: 0,
      focused: true,
      sessionWindowClosed: false,
      showEmojiPicker: false,
      preventEmojiClose: false,
      pickerLeft: 0,
      pickerTop: 0,
      emojiTarget: null,
      SBColors,
      PillMessageType,
      SBAvatarImageSize,
    };
  },
  computed: {
    ...mapGetters({
      activeConversation: 'chat/activeConversation',
      addConversationActivity: 'chat/addConversationActivity',
      addMessage: 'chat/addMessage',
      removeMessage: 'chat/removeMessage',
      removeConversationActivity: 'chat/removeConversationActivity',
      chatFastReload: 'chat/chatFastReload',
      // members: 'merchant/members',
      membersLookup: 'organisation/currentOrganisationMembersLookup',
      messageList: 'chat/messageList',
      messagesLoaded: 'chat/messagesLoaded',
      messagesLoading: 'chat/messagesLoading',
      messageCountChange: 'chat/messageCountChange',
      newMessageConversation: 'pusher/newMessageConversation',
      newConversationActivity: 'pusher/newConversationActivity',
      currentOrganisation: 'organisation/currentOrganisation',
      conversationActivity: 'pusher/conversationActivity',
      sentMessageStatusFromPusher: 'pusher/sentMessageStatus',
      messageSent: 'chat/messageSent',
      templateMessageFailed: 'notification/templateMessageFailed',
      me: 'organisation/me',
      reloadFirstPage: 'chat/reloadFirstPage',
      reconnectChannel: 'pusher/reconnectChannel',
      forceResync: 'organisation/forceResync',
      apiError: 'chat/apiError',
      updateConversations: 'chat/updateConversations',
      incognito: 'user/incognito',
      cloudApiSupport: 'organisation/cloudApiSupport',
      getMemberByPlatformId: 'organisation/getMemberByPlatformId',
      pusherEmojiReactionReceived: 'chat/pusherEmojiReactionReceived',
    }),
    version() {
      return process.env.VUE_APP_VERSION;
    },
    contactIsBlocked() {
      return this.activeConversation && this.activeConversation.blocked;
    },
    contactOpOuted() {
      return this.activeConversation && this.activeConversation.contact && !this.activeConversation.contact.has_messaging_consent;
    },
    conversationSelected() {
      return !this.emptyObject(this.activeConversation || {});
    },
    hasMorePages() {
      let lastPage = true;
      if (this.meta && this.meta.has_older) {
        lastPage = false;
      } else if (
        !this.meta &&
        this.messageList &&
        this.messageList.meta &&
        this.messageList.meta.has_older
      ) {
        lastPage = false;
      }

      if (
        this.activeConversation &&
        this.activeConversation.id &&
        this.activeConversation.id.startsWith('LOAD')
      ) { // case when the conversation is created via start new conversation flow and we do not have the conversation data ready and we are waiting for it.
        lastPage = true;
      }

      return !lastPage;
    },
    tempConversation() {
      return this.activeConversation && this.activeConversation.waitingForRealConversation;
    },
    noMoreMessages() {
      return !this.hasMorePages && !this.forceLoadingSpinner;
    },
    conversationIsUnread() {
      return (
        Object.keys(this.pillMessages).length ||
        !this.activeConversation.seen ||
        (!this.activeConversation.assignment_seen &&
          this.activeConversation.user_id === this.userId)
      );
    },
    latestMessage() {
      return this.messages
        .slice()
        .reverse()
        .find(message => message.direction !== 'activity');
    },
    latestInboundMessage() {
      return this.messages
        .slice()
        .reverse()
        .find(message => message.direction === 'inbound');
    },
    messagesChunks() {
      const chunks = [];
      let tempChunk = [];

      this.messages.forEach((message, index) => {
        if (!message.timestamp) {
          message.timestamp = message.sent_at ? message.sent_at : (message.data.timestamp ? message.data.timestamp : Date.now());
        }
        if (!message.ai_file_sources && message.data && message.data.ai_file_sources) {
          message.ai_file_sources = message.data.ai_file_sources;
        }
        if (message.ai_reasoning) {
          message.thoughts = this.parseThoughts(message.ai_reasoning);
        }
        if (
          tempChunk.length &&
          index > 0 &&
          !this.isSameDay(message.timestamp, this.messages[index - 1].timestamp)
        ) {
          chunks.push(tempChunk);
          tempChunk = [];
        }
        tempChunk.push(message);
      });

      if (tempChunk.length) {
        chunks.push(tempChunk);
      }

      return chunks;
    },
    lastMessageBeforeYesterday() {
      let before = false;
      if (!this.messagesChunks || !this.messagesChunks[0] || !this.messagesChunks[0][0]) {
        return before;
      }
      let valueMoment;
      if (this.messagesChunks[0][0].timestamp.toString().indexOf('-') >= 0) {
        valueMoment = moment(this.messagesChunks[0][0].timestamp);
      } else {
        valueMoment = moment(false, false).unix(this.messagesChunks[0][0].timestamp);
      }

      if (!valueMoment.isSame(Date.now(), 'day') && !valueMoment.isSame(moment().subtract(1, 'days'), 'day')) {
        before = true;
      }
      return before;
    },
  },
  watch: {
    activeConversation(newAC, oldAC) {
      if (newAC.id === oldAC.id) {
        return;
      }

      if (this.activeConversation.ignore) {
        const inboundMessages = this.messages.slice().filter(m => m.direction === 'inbound');
        try {
          this.lastSeenMessageTimestamp = inboundMessages.length ? inboundMessages.reverse()[this.activeConversation.message_unseen_count - 1].timestamp : null;
        } catch (error) {
          this.lastSeenMessageTimestamp = null;
        }
        this.unseenMarkerCount = this.activeConversation.message_unseen_count;
        this.showTheUnseenMarker =
          (this.activeConversation.message_unseen_count && ((!this.activeConversation.seen || this.activeConversation.user_id === this.me.id) || (!this.activeConversation.user_id && !this.activeConversation.seen))) ||
          (!this.activeConversation.assignment_seen && this.activeConversation.user_id === this.me.id);
        return;
      }

      if (!this.activeConversation.waitingForRealConversation) {
        this.forceLoadingSpinner = true;
        this.unseenMarkerCount = this.activeConversation.message_unseen_count;
        this.messages = [];
      }

      this.clearPillMessages();
      this.resetPagination();
      if (
        this.activeConversation &&
        this.activeConversation.id &&
        !this.activeConversation.id.startsWith('TEMP-conversation') &&
        !this.activeConversation.id.startsWith('LOAD-conversation')
      ) {
        this.showTheUnseenMarker =
            (this.activeConversation.message_unseen_count && ((!this.activeConversation.seen || this.activeConversation.user_id === this.me.id) || (!this.activeConversation.user_id && !this.activeConversation.seen))) ||
            (!this.activeConversation.assignment_seen && this.activeConversation.user_id === this.me.id);
        let delay = 0;
        if (this.activeConversation.waitingForRealConversation) { // we need to give some time to backend to set the template message and create conversation. Otherwise we get an empty message list.
          delay = 2000;
        }
        setTimeout(() => {
          this.loadMessages();
        }, delay);
      }
    },
    addMessage() {
      const messageData = this.addMessage.message || this.addMessage.activity;
      this.messages.push(messageData);
      this.messages = this.$lodash.uniqBy(this.messages, 'sid');
      this.$nextTick(() => {
        this.handleNewMessage(true);
      });
    },
    removeMessage() {
      const targetMessageIndex = this.messages.findIndex(message => message.sid === this.removeMessage);
      if (targetMessageIndex >= 0) {
        this.messages.splice(targetMessageIndex, 1);
      }
    },
    messageCountChange() {
      this.nextMessagesBefore = this.messageList.meta && this.messageList.meta.next_messages_before ? this.messageList.meta.next_messages_before : 0;
      this.lastPage = !this.nextMessagesBefore;

      this.messages = this.$lodash.uniqBy([...this.messages], 'sid');
    },
    reloadFirstPage() {
      this.reloadFirstPageNow();
    },
    sentMessageStatusFromPusher(message) {
      if (message.conversation_uid === this.activeConversation.id) {
        const targetMessage = this.messages.find(m => m.sid === message.sid || m.id === message.sid);
        if (targetMessage) {
          if (deliveryStatusLevels.indexOf(targetMessage.status) < deliveryStatusLevels.indexOf(message.status)) {
            targetMessage.status = message.status;
          }
        }
      }

      this.setFixedStatuses(message);
    },
    messagesLoaded(conversation) {
      setTimeout(() => {
        if (conversation && this.activeConversation && conversation === this.activeConversation.id) {
          // TODO check if this is needed
          if (!this.emptyObject(this.messageList || {})) {
            // This was used on the v1 to scroll down to where the view was before the new messages were prepended
            // const messageToScroll = this.messageList.data[0].sid;
            if (this.page === 1) {
              this.saveFirstPageOfMessages({
                conversationId: conversation,
                messageList: this.$lodash.cloneDeep(this.messageList),
              });
              this.messages = [];
              this.messages = this.$lodash.reverse(this.messageList.data);
              this.moveToBottom(false);
            } else if (this.messageList.data.length && this.emptyObject(this.apiError)) {
              this.messages = this.$lodash.concat(
                this.$lodash.reverse(this.messageList.data),
                this.messages,
              );
              this.$nextTick(() => {
                this.$refs.messageScrollbar.scrollToPreviousPosition();
              });
            }
          } else {
            this.messages = [];
          }

          // Prevents accidental duplicate message received from BE
          this.messages = this.$lodash.uniqBy(this.messages, 'sid');

          this.messages.forEach((m) => {
            if (m.context_preview && m.context_preview.length) {
              m.context_preview.forEach((c) => {
                if (c.field_type === 'main_url' && c.value && !c.value.url) {
                  // legacy data fallback - if value is string then convert it to object as expected
                  c.value = {
                    description: '',
                    image: '',
                    title: '',
                    url: c.value,
                  };
                }
              });
            } else {
              delete m.context_preview;
            }
          });

          this.meta = this.messageList.meta;

          this.nextMessagesBefore = this.messageList.meta.next_messages_before;
          this.lastPage = !this.nextMessagesBefore;

          // Find last read message so we can mark as read all the messages before it.
          if (this.messages.length) {
            const targetMessage = this.messages.slice().reverse().find(message => ['outbound'].includes(message.direction) && message.status === 'read');
            this.lastReadMessageTime = targetMessage ? targetMessage.timestamp : 0;
          }

          this.$eventBus.$emit('real-conversation-received', this.activeConversation.id);
        }

        this.finalizeSplashView();
      }, 0);
    },
    /** Updates the initial sid and status of the message. */
    messageSent() {
      if (this.messageSent.conversation_id === this.activeConversation.id) {
        const message = this.messages.find(message => message.sid === this.messageSent.temp_sid);
        if (message) {
          message.sid = this.messageSent.sid;
          if (!this.messageSent.ref) {
            message.status = 'sent';
          }
        } else { // Check if this is maybe a reaction refference
          const message = this.messages.find(message => message.reactionRef === this.messageSent.temp_sid);
          if (message) {
            this.$eventBus.$emit('emoji-reaction', { // Move this to reffernce event
              conversationId: this.messageSent.conversation_id,
              last_message: this.messageSent.message,
              sender: message.reactionSenderRef,
              sender_icon: message.reactionSenderIconRef,
            });
          }
        }
      }
    },
    newMessageConversation(messageData) {
      // Moving to messages from done to open doesn't sends a activity event but every new message does and it automatically moves the conversation to open
      if (messageData.conversation_uid === this.activeConversation.id) {
        this.activeConversation.folder = 'open';
      }
      let messageExists = false;
      if (messageData.message.direction !== 'inbound') {
        messageExists = this.messages.find(
          message => message.sid && messageData.message && messageData.message.temp_sid && message.sid === messageData.message.temp_sid,
        );
        if (!messageExists) {
          // TODO this is probably not needed since all outbound messages have temp_sid
          messageExists = this.messages.find(
            message => message.sid && messageData.message && messageData.message.sid && message.sid === messageData.message.sid,
          );
        }
      }
      // only add the message to the cache if the first page has been loaded to cache first
      if (this.chatFastReload[messageData.conversation_uid] && !messageExists) {
        this.addMessageToFastLoad(messageData);
      }

      if (this.activeConversation.id === messageData.conversation_uid && !messageExists) {
        this.isScrollPositionOnBottomBeforeNewInboundMessage = this.$refs.messageScrollbar.isPositionedOnBottom();
        // this.messages.push(messageData.message);
        this.messages = this.$lodash.uniqBy([...this.messages, messageData.message], 'sid');
        this.$nextTick(() => {
          this.handleNewMessage();
        });
      }
    },
    newConversationActivity(payload) {
      this.addMessageToFastLoad(payload);
      if (this.activeConversation.id === payload.conversation.id) {
        this.isScrollPositionOnBottomBeforeNewInboundMessage = this.$refs.messageScrollbar.isPositionedOnBottom();
        this.messages.push(payload.activity);
        this.$nextTick(() => {
          this.handleNewMessage();
        });
      }
    },
    conversationActivity(payload) {
      this.addMessageToFastLoad(payload);
      if (this.activeConversation.id === payload.conversation_uid) {
        this.isScrollPositionOnBottomBeforeNewInboundMessage = this.$refs.messageScrollbar.isPositionedOnBottom();
        this.messages.push(payload.activity);
        this.$nextTick(() => {
          this.handleNewMessage();
        });
      }
    },
    addConversationActivity(payload) {
      this.isScrollPositionOnBottomBeforeNewInboundMessage = this.$refs.messageScrollbar.isPositionedOnBottom();
      const outboundActivity = JSON.parse(JSON.stringify(payload.outboundData));
      if (!outboundActivity.sid) {
        outboundActivity.sid = randomString(10);
      }
      this.messages.push(outboundActivity);
      // This next two lines needs to be standardized data during rewrite
      payload.conversation_uid = payload.conversationId;
      payload.activity = payload.outboundData;
      this.addMessageToFastLoad(payload);

      this.$nextTick(() => {
        this.handleNewMessage(true);
      });
    },
    removeConversationActivity(payload) {
      this.messages = [...this.messages.filter(message => !message.temp_sid || message.temp_sid !== payload.outboundData.temp_sid)];
      this.removeMessageFromFastReload(payload);

      this.showToaster('User assign failed. Please try again.', null, null, 'error');
    },
    messages() {
      // This can't be computed becase it would recalculate on each new message received and the bar would drop to last message all the time.
      this.unseenMarkerCount = this.activeConversation.message_unseen_count;
      if (this.unseenMarkerCount) {
        const inboundMessages = this.messages.slice().reverse().filter(message => message.direction === 'inbound');
        if (inboundMessages.length > this.unseenMarkerCount) {
          const targetMessage = inboundMessages[this.unseenMarkerCount - 1];
          if (targetMessage && targetMessage.timestamp) {
            this.lastSeenMessageTimestamp = targetMessage.timestamp;
          }
        }
      }

      if (!this.focused) {
        this.showTheUnseenMarker =
          (this.activeConversation.message_unseen_count && ((!this.activeConversation.seen || this.activeConversation.user_id === this.me.id) || (!this.activeConversation.user_id && !this.activeConversation.seen))) ||
          (!this.activeConversation.assignment_seen && this.activeConversation.user_id === this.me.id);
      }
    },
    templateMessageFailed() {
      const message = this.messages.find(m => this.templateMessageFailed.conversationId === this.activeConversation.id && m.sid === this.templateMessageFailed.tempSid);

      if (message) {
        message.status = 'failed';
        if (!this.checkPermission('send_notifications')) {
          this.showToaster('You don’t have a permission to send template messages.', null, null, 'warning');
        }
      }
    },
    updateConversations(newValue) {
      if (newValue.conversations.includes(this.activeConversation.id)) {
        this.reloadFirstPageNow();
      }
    },
    pusherEmojiReactionReceived() {
      if (this.pusherEmojiReactionReceived.businessId === this.activeConversation.business_id && this.pusherEmojiReactionReceived.conversationId === this.activeConversation.id) {
        const targetMessage = this.messages.find(m => m.id === this.pusherEmojiReactionReceived.message_id);
        if (targetMessage) {
          if (!targetMessage.reaction) {
            targetMessage.reaction = [];
          }

          if (this.pusherEmojiReactionReceived.sender.name === 'contact') {
            targetMessage.reaction = targetMessage.reaction.filter(r => r.sender.name !== 'contact');
          } else {
            targetMessage.reaction = targetMessage.reaction.filter(r => r.sender.name === 'contact');
          }
          if (this.pusherEmojiReactionReceived.emoji) { // This prevents empty emoji from poping up as empty bubble. Empty emoji means someone deleted its reaction.
            targetMessage.reaction.push({
              sender: this.pusherEmojiReactionReceived.sender,
              emoji: this.pusherEmojiReactionReceived.emoji,
            });
          }
          this.messages = [...this.messages];
        }
      }
    },
  },
  created() {},
  mounted() {
    this.$eventBus.$on('scroll-to-bottom-messages', this.scrollToBottomOnEvent);
    this.$eventBus.$on('addoutboundmessage', this.addOutboundMessage);
    this.$eventBus.$on('removeoutboundmessage', this.removeOutboundMessage);
    this.$eventBus.$on('pillmessage', this.processPillMessage);
    this.$eventBus.$on('set-temp-message', (message) => {
      this.messages.push(message);
    });

    this.$eventBus.$on('24-hour-window-closed', (state) => { this.sessionWindowClosed = state; });
    window.addEventListener('focus', this.onFocus);
    window.addEventListener('blur', this.onBlur);
    this.loadMessages();
  },
  updated() {},
  beforeDestroy() {
    this.$eventBus.$off('addoutboundmessage', this.addOutboundMessage);
    this.$eventBus.$off('removeoutboundmessage', this.removeOutboundMessage);
    this.$eventBus.$off('pillmessage', this.processPillMessage);
    window.removeEventListener('blur', this.onBlur);
    window.removeEventListener('focus', this.onFocus);
  },
  methods: {
    ...mapActions({
      addMessageToFastLoad: 'chat/addMessageToFastLoad',
      removeMessageFromFastReload: 'chat/removeMessageFromFastReload',
      fetchMessages: 'chat/fetchMessages',
      markConversationAsSeen: 'chat/markConversationAsSeen',
      setMessages: 'chat/setMessages',
      emojiReaction: 'chat/emojiReaction',
      saveFirstPageOfMessages: 'chat/saveFirstPageOfMessages',
      finalizeSplashView: 'organisation/finalizeSplashView',
    }),
    /** Removes all pill messages. */
    clearPillMessages() {
      this.pillMessages = {};
    },
    followLink(url) {
      if (url) {
        window.open(url, '_blank');
      }
    },
    onBlur() {
      this.focused = false;
    },
    onFocus() {
      this.focused = true;
      if (
        this.activeConversation.id &&
        this.$refs.messageScrollbar &&
        (this.$refs.messageScrollbar.isPositionedOnBottom || !this.$refs.messageScrollbar.verticalScrollActive)
      ) {
        setTimeout(() => {
          if (this.activeConversation.id) {
            this.messagesSeen(true);
          }
        }, 1000);
      }
    },
    isInDynPopover(currentElement, id) {
      return currentElement.closest(`.dyn-popover-${id}`);
    },
    isInMessage(currentElement, id) {
      return currentElement.closest(`#message-target-${id}`);
    },
    showTooltip(messageSid) {
      if (this.$refs[`message-failed-info-ref-${messageSid}`]) this.$refs[`message-failed-info-ref-${messageSid}`][0].$emit('open');
    },
    hideTooltip(messageSid) {
      setTimeout(() => {
        const currentElement = document.elementFromPoint(window.mouse.x, window.mouse.y);
        const popoverElement = this.isInDynPopover(currentElement, messageSid);
        const inMessage = this.isInMessage(currentElement, messageSid);
        if (popoverElement || inMessage) {
          // set listener on popover leave
          if (popoverElement) {
            popoverElement.addEventListener('mouseleave', () => {
              this.hideTooltip(messageSid);
            });
          }
        } else if (this.$refs[`message-failed-info-ref-${messageSid}`]) {
          this.$refs[`message-failed-info-ref-${messageSid}`][0].$emit('close');
        }
      }, 50);
    },
    /** Scrolls to bottom with animation if the list is on bottom at the moment the message is received. Othervise just shows the info box about new message. */
    handleNewMessage(preventPill = false) {
      if (this.isScrollPositionOnBottomBeforeNewInboundMessage) {
        this.moveToBottom();
      } else if (
        !preventPill &&
        this.$refs.messageScrollbar.verticalScrollActive &&
        !this.showScrollBottomShown
      ) {
        setTimeout(() => {
          if (!this.showScrollBottomShown && !this.$refs.messageScrollbar.isPositionedOnBottom()) {
            // Only add the message if it is not allready shown
            const pillId = randomString();
            this.pillScrollBottomId = pillId;
            this.pillMessages[pillId] = {
              message: 'You have unread messages. Scroll to bottom',
              callback: (id) => {
                this.removePill(id, true);
                this.moveToBottom();
              },
              type: PillMessageType.INFO,
              iconLeft: SBIconList.DOWNLOAD,
              closeBtn: false,
            };
            this.pillMessages = { ...this.pillMessages };
            this.showScrollBottomShown = true;
          }
        }, 1000);
      }
    },
    /**
     * Adds outbound message to the currently loaded conversation.
     *
     * @param payload Object ot type message
     *                  {
     *                     sid: ...,
     *                     body: ...,
     *                     media_type: ...,
     *                     media_url: ...,
     *                     loading: boolean,
     *                     direction: DIRECTION,
     *                     status: STATUS,
     *                     sent_at: String,
     *                   }
     */
    addOutboundMessage(payload) {
      // TODO add some checks
      this.activeConversation.last_message = payload.media_type ? payload.media_type : payload.body;
      this.activeConversation.message_direction = payload.direction;
      this.activeConversation.message_sent_at = payload.timestamp;
      delete this.activeConversation.broadcast;
      this.$eventBus.$emit('newmessagesent', {
        conversation_id: this.activeConversation.id,
        last_message: payload.body,
        media_type: payload.media_type,
        message_direction: payload.direction,
        message_sent_at: payload.timestamp,
        agent: payload.agent,
        sender: payload.sender,
        sender_icon: payload.sender_icon,
      });

      this.messages.push(payload);
      this.$nextTick(() => {
        if (this.$refs.messageScrollbar) {
          this.$refs.messageScrollbar.scrollToBottom();
        }
      });
    },
    removeOutboundMessage(messageData) {
      const index = this.messages.findIndex(message => message.sid === messageData.sid);
      this.messages.splice(index, 1);
      // TODO remove from cachemessages
    },
    isRightAlignedText,
    // TODO - This method should be refactored because now we have 'messaging_consent_disabled' action which doesn't have 'from_user_id' which complicates things a bit
    configureActivityMessage(activity) {
      if (activity.action === 'ai_sent_email') {
        return '✉️ This conversation\'s summary was sent to your email.';
      }

      const fromUser = this.membersLookup[activity.from_user_id];
      if (!fromUser) {
        // return '';
      }
      const elapsedSeconds = this.$moment().diff(
        this.$moment(false, false).unix(activity.timestamp),
        'seconds',
      );
      const actionTime = this.$moment(false, false)
        .unix(activity.timestamp)
        .fromNow(!(elapsedSeconds > 44)); // add 'ago' suffix only if more than 45 seconds have passed since that is the break point when it shows '1m' instead of 'Now'
      const toUser = activity.to_user_id ? this.membersLookup[activity.to_user_id] : null;
      const fromUserName = fromUser && fromUser.id === this.userId ? 'You' : fromUser ? fromUser.name : '';
      let toUserName = null;
      if (toUser && fromUser) {
        if (toUser.id === this.userId) {
          toUserName = fromUser.id === this.userId ? 'yourself' : 'you';
        } else {
          toUserName = fromUser.id === toUser.id ? 'themself' : toUser.name;
        }
      }

      let incognitoTime = '';
      if (this.incognito) {
        incognitoTime = ` (${this.$options.filters.subMessageDate(activity.timestamp)})`;
      }

      // TODO - add other messages from 'Blocked new 4' screen from zeplin
      switch (activity.action) {
        case 'assignment': {
          const assignment = toUserName
            ? `assigned conversation to ${toUserName}`
            : 'unassigned conversation';
          return `${fromUserName} ${assignment} ${actionTime}.${incognitoTime}`;
        }
        case 'folder': {
          const oldFolder = activity.meta_data.old_folder.replace(/\b\w/g, l => l.toUpperCase());
          const newFolder = activity.meta_data.new_folder.replace(/\b\w/g, l => l.toUpperCase());
          return `${fromUserName} moved conversation from ${oldFolder} to ${newFolder} ${actionTime}.`;
        }
        case 'status_available':
          return `${fromUserName} changed conversation status to available ${actionTime}.`;
        case 'status_away':
          return `${fromUserName} changed conversation status to away ${actionTime}.`;
        case 'Block':
          return `🚫 ${fromUserName} blocked this contact ${actionTime}.`;
        case 'Unblock':
          return `👍 ${fromUserName} unblocked this contact ${actionTime}.`;
        case 'messaging_consent_disabled':
          return `⛔ ${this.activeConversation.contact.name ? this.activeConversation.contact.name : this.activeConversation.contact.phone} opted-out from receiving messages.`;
        case 'changed_number':
          return `📞 ${this.activeConversation.contact.name ? this.activeConversation.contact.name : this.activeConversation.contact.phone} has changed their WhatsApp number. To continue chatting, please contact them at ${this.$options.filters.phoneFormat(activity.meta_data.new_number)}.`;
        default:
          return '';
      }
    },
    handleTopScroll() {
      // console.log('th');
      if (!this.messagesLoading) {
        // console.log('lm');
        this.loadMessages();
      }
    },
    handleBottomScroll() {
      this.removePill(this.pillScrollBottomId);
      this.showScrollBottomShown = false;
      setTimeout(() => {
        if (this.activeConversation.id) {
          this.messagesSeen(true);
        }
      }, 1000);
      this.finalizeSplashView();
    },
    messagesSeen(seen) {
      if (!this.conversationIsUnread || !document.hasFocus()) {
        return;
      }
      const targetConversation = this.activeConversation.id;
      this.markConversationAsSeen({
        organisationId: this.currentOrganisation.id,
        merchant_id: this.activeConversation.business_id,
        conversation_id: this.activeConversation.id,
        folder: this.activeConversation.folder,
        data: {
          seen,
          includeMe: false,
        },
      })
        .then((response) => {
          if (response.status === 200) {
            this.$eventBus.$emit('reset-unread-counter', targetConversation);
          }
        });
    },
    // TODO this will probably not be needed
    isAudioMessage() {
      return false;
      // return !!(message.media_type && message.media_type.indexOf('audio') === 0 && message.media_url);
    },
    isMediaMessage(message) {
      return !!(
        message.media_type &&
        message.media_type !== 'location' &&
        message.media_url
      );
    },
    loadMessages() {
      if (!this.activeConversation.id || !this.activeConversation.business_id) {
        console.log('lm -');
        return;
      }
      this.page++;
      const businessId = this.activeConversation.business_id;

      // First check if the chat is available in the state for fast reload.
      if (this.page === 1 && this.chatFastReload[this.activeConversation.id]) {
        this.forceLoadingSpinner = true;
        setTimeout(() => { // This speeds up conversation change for a moment because it allows the cycle to finish and shows the correct conversation after which it gets to cache and takes the messages from it.
          this.messages = this.$lodash.uniqBy([...this.chatFastReload[this.activeConversation.id].data].reverse(), 'sid');
          this.meta = this.chatFastReload[this.activeConversation.id].meta;
          this.forceLoadingSpinner = false;
          this.moveToBottom(false);
        }, 1);
      } else if (this.page === 1 || this.hasMorePages) {
        const payload = {
          organisationId: this.currentOrganisation.id,
          merchant_id: businessId,
          conversation_id: this.activeConversation.id,
          filters: {
            older: 50,
            sent_at: Math.ceil(Date.now() / 1000) + 10000, // get 50 from now but add 10 seconds in the future just in case some message arrives milisecond after the request
            // newer: 1,
          },
        };
        if (this.messages.length && !this.activeConversation.waitingForRealConversation) {
          payload.filters.sent_at = this.messages[0].timestamp;
        }
        this.fetchMessages(payload);
        this.$nextTick(() => {
          setTimeout(() => {
            this.forceLoadingSpinner = false;
          }, 100);
        });
      }
    },
    isLessThanAMinuteApart(previousMessage, focusMessage) {
      const secondsDiff = Math.abs(
        moment(false, false)
          .unix(focusMessage)
          .diff(moment(false, false).unix(previousMessage), 'seconds'),
      );
      return secondsDiff >= 0 && secondsDiff < 60;
    },
    isSameDay(testDate, compareDate) {
      return moment(false, false)
        .unix(testDate)
        .isSame(moment(false, false).unix(compareDate), 'day');
    },
    isSameMinute(testDate, compareDate) {
      // Using moment isSame method with 'day' as a checking unit does not work for some reason so I had to do it like this.
      return (
        moment(testDate).format('YYYYMMDDHHmm') ===
        moment(compareDate).format('YYYYMMDDHHmm')
      );
    },
    messagePositionInGroup(previousMessage, focusMessage, nextMessage) {
      const positions = [];
      // Message can have more than one position. e.g. it can be first but also the last one in the block
      // First if minute is different than the previous message or if the direction is different.
      if (
        !focusMessage.context_preview &&
        (
          !previousMessage ||
          previousMessage.context_preview ||
          focusMessage.status === 'failed' ||
          previousMessage.status === 'failed' ||
          (previousMessage && previousMessage.direction !== focusMessage.direction) ||
          (previousMessage &&
            !this.isLessThanAMinuteApart(previousMessage.timestamp, focusMessage.timestamp)) ||
          (focusMessage.sender !== previousMessage.sender) ||
          (focusMessage && focusMessage.context)
        )
      ) {
        positions.push('first');
      }

      // Middle if the minute is the same as as previous message and the direction is the same
      // but there is no need to return the middle result.

      // Last if the minute is different than the next message or the direction is different than the next message.
      if (
        !nextMessage ||
        focusMessage.status === 'failed' ||
        nextMessage.status === 'failed' ||
        (nextMessage && nextMessage.direction !== focusMessage.direction) ||
        (nextMessage &&
          !this.isLessThanAMinuteApart(nextMessage.timestamp, focusMessage.timestamp)) ||
        (nextMessage && nextMessage.context) ||
        (focusMessage.sender !== nextMessage.sender) ||
        focusMessage.context_preview ||
        nextMessage.context_preview
      ) {
        positions.push('last');
      }

      return positions;
    },
    /**
     * Scrolls the message list to bottom.
     *
     * @param animation Flag for the animation to be applied to scroll movement.
     */
    moveToBottom(animation = true) {
      this.$nextTick(() => {
        if (this.$refs.messageScrollbar) {
          this.$refs.messageScrollbar.scrollToBottom(animation);
        } else {
          setTimeout(() => {
            this.moveToBottom(animation);
          }, 100);
        }
        this.showScrollBottomShown = false;
      });
    },
    toggleEmoji(e, message) {
      this.preventEmojiClose = true;
      const canItFitOnBottom = e.srcElement.parentElement.offsetTop + 24 + 420 < this.$refs.messageScrollbar.$el.scrollHeight;
      let left = this.$refs.messageScrollbar.$el.offsetWidth - (e.srcElement.parentElement.offsetLeft + 345) > 0 ? e.srcElement.parentElement.offsetLeft : this.$refs.messageScrollbar.$el.offsetWidth - 350;
      left = left < 0 ? 0 : left;
      if (canItFitOnBottom) {
        this.pickerTop = `${e.srcElement.parentElement.offsetTop + 24}px`;
        this.pickerLeft = `${left}px`;
      } else {
        this.pickerTop = `${e.srcElement.parentElement.offsetTop - 420}px`;
        this.pickerLeft = `${left}px`;
      }
      if (message.direction === 'outbound') {
        left = this.$refs.messageScrollbar.$el.offsetWidth - (e.srcElement.parentElement.offsetLeft + 24 - 345) < 0 ? 0 : e.srcElement.parentElement.offsetLeft + 24 - 345;
        left = left < 0 ? 0 : left;
        this.pickerLeft = `${left}px`;
      }

      if (this.emojiTarget && message.id === this.emojiTarget.id) {
        this.showEmojiPicker = false;
        this.preventEmojiClose = false;
        this.emojiTarget = {};
      } else {
        this.showEmojiPicker = true;
        this.preventEmojiClose = true;
        this.emojiTarget = message;
        setTimeout(() => { this.preventEmojiClose = false; }, 100);
      }
    },
    closeEmojis(e) {
      if (!e.srcElement.parentElement.dataset.emojiSelector && !this.preventEmojiClose) {
        this.showEmojiPicker = false;
        this.preventEmojiClose = false;
        this.emojiTarget = {};
      }
    },
    removeEmoji(e, message) {
      message.reaction = message.reaction.filter(r => r.sender.name === 'contact');
      this.emojiTarget = message;
      this.emojiSelected({ native: 'delete' });
    },
    /**
     * Callback which triggers when emoji is selected.
     *
     * @param emoji Emoji object
     */
    emojiSelected(emoji) {
      this.showEmojiPicker = false;
      if (!this.emojiTarget.reaction) {
        this.emojiTarget.reaction = [];
      }
      if (!this.emojiTarget.reactionRef) {
        this.emojiTarget.reactionRef = null;
      }

      const messageIdBackup = this.emojiTarget.id.toString();
      const messageEmojiBackup = this.emojiTarget.reaction.find(r => r.sender.name !== 'contact');

      this.emojiTarget.reaction = this.emojiTarget.reaction.filter(r => r.sender.name === 'contact');
      if (emoji.native !== 'delete') {
        this.emojiTarget.reaction.push({
          sender: {
            id: this.me.platform_id,
            name: this.me.name,
          },
          emoji: emoji.native,
        });
      }
      this.emojiReaction({
        organisationId: this.currentOrganisation.id,
        businessId: this.activeConversation.business_id,
        conversationId: this.activeConversation.id,
        data: {
          emoji_reaction: emoji.native,
          context_id: this.emojiTarget.id,
        },
      })
        .then((response) => {
          if (response.status === 200) {
            const targetMessage = this.messages.find(m => m.id === messageIdBackup);
            if (targetMessage) {
              targetMessage.reactionRef = response.data.message_reference_id;
              targetMessage.reactionSenderRef = this.me.name;
              targetMessage.reactionSenderIconRef = this.me.platform_id;
            }
          }
        })
        .catch((error) => {
          const targetMessage = this.messages.find(m => m.id === messageIdBackup);
          if (targetMessage) {
            targetMessage.reaction = targetMessage.reaction.filter(r => r.sender.name === 'contact');
            if (messageEmojiBackup) {
              targetMessage.reaction.push(messageEmojiBackup);
            }
          }
        });
      this.emojiTarget = {};
    },
    /** Only move to bottom if scroll offset is less than 100px. This means that the input field has just shown due to new inbound message so we just need to reset the view. */
    scrollToBottomOnEvent() {
      if (this.$refs.messageScrollbar) {
        const fromBottom = this.$refs.messageScrollbar.$el.scrollHeight - this.$refs.messageScrollbar.$el.offsetHeight - this.$refs.messageScrollbar.$el.scrollTop;
        if (fromBottom < 100) {
          this.moveToBottom();
        }
      }
    },
    /**
     * Removes the pill message from the list.
     *
     * @param id Id of the message to be removed.
     * @param noAnimation Flag to define if the message will be removed with or without animation.
     */
    removePill(id, noAnimation = false) {
      if (noAnimation) {
        addClass(this.$refs[`pillMessage-${id}`][0], 'no-animation');
      }
      delete this.pillMessages[id];
      this.pillMessages = { ...this.pillMessages };
    },
    parseThoughts(thoughts) {
      const regex = /^(\*\*(.*?)\*\*){0,1}(.*)$/s;
      const parsedThoughts = [];
      thoughts.forEach((reasoning) => {
        const match = reasoning.match(regex);
        if (match) {
          parsedThoughts.push({
            title: match[2],
            description: match[3],
          });
        }
      });
      return parsedThoughts;
    },
    /**
     * Converts the received pill message into pill object.
     *
     * @param message Message to be shown as a pill.
     */
    processPillMessage(message) {
      const pillId = randomString();
      this.pillMessages[pillId] = {
        message,
        callback: null,
        type: PillMessageType.ERROR,
        closeBtn: true,
      };
      this.pillMessages = { ...this.pillMessages };
      setTimeout(() => {
        this.removePill(pillId);
      }, 5000);
    },
    /**
     * Resets the messages pagination.
     */
    resetPagination() {
      this.page = 0;
    },
    /**
     * Resends the failed message.
     *
     * @param message Message object that needs to be resent.
     */
    sendRetry(message) {
      // console.log('RETRY', message);

      const tempSid = randomString();

      // const payload = {
      //   organisationId: this.currentOrganisation.id,
      //   businessId: this.activeConversation.business_id,
      //   conversationId: this.activeConversation.id,
      //   data: {
      //     message_uid: message.id,
      //   },
      // };

      const outboundMessageData = {
        ...message,
        sid: tempSid,
        status: 'sending',
        timestamp: this.$moment().unix(),
      };

      // this.resendMessage(payload);
      const targetMessageIndex = this.messages.findIndex(m => m.id === message.id);
      if (targetMessageIndex >= 0) {
        this.messages.splice(targetMessageIndex, 1);
      }
      this.addOutboundMessage(outboundMessageData);
    },
    /**
     * Sometimes we do not get status updates for some messages so if a message has a status 'sent' or 'delivered' and the message after it has the higher status like 'read' then apply that higher status to all preceding messages.
     * TODO for rewrite, trigger it on messages after every message list page is loaded.
     */
    setFixedStatuses(statusUpdate) {
      if (statusUpdate.conversation_uid !== this.activeConversation.id) {
        return;
      }

      let targetMessageIndex = this.messages.findIndex(message => message.sid === statusUpdate.sid);

      if (targetMessageIndex >= 0) {
        if (deliveryStatusLevels.indexOf(this.messages[targetMessageIndex].status) < deliveryStatusLevels.indexOf(statusUpdate.status)) {
          this.messages[targetMessageIndex].status = statusUpdate.status;
        }
      }

      const maxWhileCount = 100;
      let whileCount = 0;
      while (
        targetMessageIndex > 0 &&
        whileCount < maxWhileCount
      ) {
        whileCount++;
        targetMessageIndex--;
        if (
          this.messages[targetMessageIndex] &&
          this.messages[targetMessageIndex].direction === 'outbound' &&
          ['sent', 'delivered'].includes(this.messages[targetMessageIndex].status) &&
          ['delivered', 'read'].includes(statusUpdate.status) &&
          this.messages[targetMessageIndex].status !== statusUpdate.status
        ) {
          this.messages[targetMessageIndex].status = statusUpdate.status;
        }
      }
    },
    /**
     * Method is used to determine if the sub message should be shown.
     * Sub message shows sender name and time the message is sent.
     *
     * @param focusMessage Message for which we are trying to find out if the sub message should be printed.
     * @param nextMessage Message that comes after the focus message which will give us the data needed to figure out if sub message needs to be shown.
     */
    showSubMessage(focusMessage, nextMessage) {
      let showIt = false;
      if (
        this.incognito ||
        !nextMessage ||
        focusMessage.status === 'failed' ||
        nextMessage.status === 'failed' ||
        (nextMessage && focusMessage.direction !== nextMessage.direction) ||
        (nextMessage &&
          !this.isLessThanAMinuteApart(focusMessage.timestamp, nextMessage.timestamp)) ||
        (nextMessage && nextMessage.context) ||
        (focusMessage.sender !== nextMessage.sender) ||
        (focusMessage.context_preview && focusMessage.context_preview.length) ||
        (nextMessage.context_preview && nextMessage.context_preview.length)
      ) {
        showIt = true;
      }
      return showIt;
    },
    reloadFirstPageNow() {
      const payload = {
        silent: true,
        organisationId: this.currentOrganisation.id,
        merchant_id: this.activeConversation.business_id,
        conversation_id: this.activeConversation.id,
        filters: {
          newer: 100,
          _: this.version,
          __: this.me.platform_id,
          ____: window.todesktop ? 'd' : 'w',
        },
      };
      if (this.messages.length) {
        payload.filters.sent_at = this.messages.slice(-1)[0].timestamp;
      }
      this.fetchMessages(payload).then((response) => {
        if (response.data.data && response.data.data.length) {
          const addMessages = response.data.data.reverse();
          this.messages = this.$lodash.uniqBy([...this.messages, ...addMessages], 'id');
        }
      });
    },
    getMemberAvatar(message) {
      const member = Object.values(this.membersLookup).find(member => member.platform_id === message.sender_icon);
      if (member) {
        return member;
      }
      return {
        avatar: '',
      };
    },
    startReply(message) {
      this.$eventBus.$emit('start-reply', message);
    },
  },
};
</script>
